var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import "../styles/Slider.css";
import SliderButtonContainer from "./SliderButtonContainer";
import SliderCarousel from "./SliderCarousel";
import SlideSelector from "./SlideSelector";
var Slider = /** @class */ (function (_super) {
    __extends(Slider, _super);
    function Slider(props) {
        var _this = _super.call(this, props) || this;
        _this.slideSelected = function (index) {
            _this.setState(function (previous) {
                return { index: index };
            });
        };
        _this.onTouchStart = function (event) {
            _this.onSwipeStart(event.touches[0].clientX);
        };
        _this.onTouchMove = function (event) {
            _this.onSwipeMove(event.touches[0].clientX);
        };
        _this.onTouchEnd = function (event) {
            _this.onSwipeStop();
        };
        _this.onMouseStart = function (event) {
            event.preventDefault();
            _this.onSwipeStart(event.clientX);
        };
        _this.onMouseMove = function (event) {
            _this.onSwipeMove(event.clientX);
        };
        _this.onMouseEnd = function (event) {
            event.preventDefault();
            _this.onSwipeStop();
        };
        _this.onSwipeStart = function (startPoint) {
            var x = startPoint;
            _this.setState(function (previous) {
                return {
                    dragStartTime: new Date(),
                    dragging: true,
                    startingX: x
                };
            });
        };
        _this.onSwipeMove = function (currentPointX) {
            var length = _this.props.images.length;
            var _a = _this.state, index = _a.index, startingX = _a.startingX;
            var offsetX = currentPointX - startingX;
            var isSwipingLeftAtFirstSlide = offsetX > 0 && index === 0;
            var isSwipingRightAtLastSlide = offsetX < 0 && index === length - 1;
            if (_this.state.dragging &&
                !isSwipingLeftAtFirstSlide &&
                !isSwipingRightAtLastSlide) {
                _this.setState(function (previous) {
                    return { offsetX: offsetX };
                });
            }
        };
        _this.onSwipeStop = function () {
            var offsetX = _this.state.offsetX;
            if (_this.state.dragging && offsetX !== 0) {
                var maxSwipeThreshold = _this.props.maxSwipeThreshold
                    ? _this.props.maxSwipeThreshold
                    : Slider.defaultProps.maxSwipeThreshold;
                var minSwipeThreshold = _this.props.minSwipeThreshold
                    ? _this.props.minSwipeThreshold
                    : Slider.defaultProps.minSwipeThreshold;
                var swipeTimeThreshold = _this.props.swipeTimeThreshold
                    ? _this.props.swipeTimeThreshold
                    : Slider.defaultProps.swipeTimeThreshold;
                var images = _this.props.images;
                var _a = _this.state, index = _a.index, dragStartTime = _a.dragStartTime;
                var nextIndex_1 = index;
                var mouseEndTime = new Date();
                var elapsedTime = mouseEndTime.getTime() - dragStartTime.getTime();
                var numberOfImages = images.length;
                var isSwipingLeft = offsetX < 0;
                var isSwipingRight = offsetX > 0;
                var canSwipeLeft = isSwipingLeft && index < numberOfImages - 1;
                var canSwipeRight = isSwipingRight && index > 0;
                var isOffsetMoreThenMaxThreshold = Math.abs(offsetX) > maxSwipeThreshold;
                var isSwipingFast = Math.abs(offsetX) > minSwipeThreshold &&
                    elapsedTime < swipeTimeThreshold;
                if ((isOffsetMoreThenMaxThreshold || isSwipingFast) &&
                    (canSwipeLeft || canSwipeRight)) {
                    if (isSwipingLeft) {
                        nextIndex_1++;
                    }
                    else {
                        nextIndex_1--;
                    }
                }
                _this.setState(function (previous) {
                    return {
                        dragging: false,
                        index: nextIndex_1,
                        offsetX: 0,
                        startingX: 0
                    };
                });
            }
            else {
                _this.setState(function (previous) {
                    return {
                        dragging: false,
                        startingX: 0
                    };
                });
            }
        };
        _this.toLeft = function () {
            var index = _this.state.index;
            if (index > 0) {
                _this.setState(function (previous) {
                    return { index: --previous.index };
                });
            }
        };
        _this.toRight = function () {
            var index = _this.state.index;
            var images = _this.props.images;
            if (index < images.length - 1) {
                _this.setState(function (previous) {
                    return { index: ++previous.index };
                });
            }
        };
        _this.state = {
            dragStartTime: new Date(),
            dragging: false,
            index: 0,
            offsetX: 0,
            startingX: 0
        };
        return _this;
    }
    Slider.prototype.render = function () {
        var _a = this.props, width = _a.width, height = _a.height, images = _a.images, directionButtonStyle = _a.directionButtonStyle, leftDirectionButtonElement = _a.leftDirectionButtonElement, rightDirectionButtonElement = _a.rightDirectionButtonElement, selectorStyle = _a.selectorStyle, slideStyle = _a.slideStyle, selectorContainerStyle = _a.selectorContainerStyle, carouselStyle = _a.carouselStyle;
        var _b = this.state, index = _b.index, offsetX = _b.offsetX;
        return (React.createElement("div", { style: { maxWidth: width }, className: "Slider-Main-Container" },
            React.createElement("div", { style: __assign({ height: height, maxWidth: width }, carouselStyle), className: "Slider-Carousel-Container", onMouseDown: this.onMouseStart, onMouseMove: this.onMouseMove, onMouseUp: this.onMouseEnd, onMouseLeave: this.onMouseEnd, onTouchStart: this.onTouchStart, onTouchMove: this.onTouchMove, onTouchEnd: this.onTouchEnd, onTouchCancel: this.onTouchEnd },
                React.createElement(SliderButtonContainer, { leftButtonOnPress: this.toLeft, rightButtonOnPress: this.toRight, directionButtonStyle: directionButtonStyle, leftDirectionButtonElement: leftDirectionButtonElement, rightDirectionButtonElement: rightDirectionButtonElement }),
                React.createElement(SliderCarousel, { height: height, width: width, images: images, offsetX: offsetX, index: index, slideStyle: slideStyle }),
                React.createElement(SlideSelector, { selectedIndex: index, onPress: this.slideSelected, selectorContainerStyle: selectorContainerStyle, numberOfSlide: images.length, selectorStyle: selectorStyle }))));
    };
    Slider.defaultProps = {
        maxSwipeThreshold: 100,
        minSwipeThreshold: 50,
        swipeTimeThreshold: 200
    };
    return Slider;
}(React.Component));
export default Slider;
//# sourceMappingURL=Slider.js.map